<main>
    <div class="container main-panel" style="padding-right: 0px !important">
        <app-header-ad [position]="'top'"></app-header-ad>
        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

        <span *ngIf="currentContentEntry">
            <app-display-content-video [content]="currentContentEntry" [timeindex]="timeindex">
            </app-display-content-video>
        </span>
        <app-header-ad [position]="'bottom'"></app-header-ad>
    </div>
</main>